module.exports = __webpack_public_path__ + "media/di2.ab853d6f.mp3";